import React from 'react';
import styled from 'styled-components';

import Heading from '../../components/heading';

/**
 * Container element
 */
const Container = styled.div`
  padding: 0.5em 2.5em;
  align-self: stretch;
`;

/**
 * Small Heading element
 */
const SmallHeading = styled.h2`
  font-size: 1.2em;
`;

/**
 * Point element
 */
const Point = styled.span`
  margin-right: 1em;
`;

/**
 * Terms of service function
 */
const TermsOfService = () => {
  return (
    <Container>
      <Heading>利用規約</Heading>
      <p>
        この利用規約（以下、「本規約」といいます。）は、プレティア・テクノロジーズ株式会社（以下、「当社」といいます。）が提供する「新感覚謎解きゲーム」（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含み、以下、「本サービス」といいます。）に関する提供条件等について定めたものです。お客様の皆様におかれましては、本サービスご利用に際しまして、本規約及びプライバシーポリシーを必ずお読みいただくようお願いいたします。本規約およびプライバシーポリシーに同意しない場合は、本サービスの利用をご遠慮ください。本サービスをご利用いただいた場合には、本規約に同意したものとみなします。
      </p>
      <SmallHeading>
        <Point>第1条</Point>本サービスの利用条件
      </SmallHeading>
      <p>
        本サービスの利用にあたり、本サービスを利用する全ての者（以下「お客様といいます。）は、本規約および適用される地方、国および国際的な法律、規則、規定のすべてに従うものとします。
      </p>
      <SmallHeading>
        <Point>第2条</Point>適用
      </SmallHeading>
      <p>
        当社が当社ウェブサイト（そのドメインが「pretiaar.com」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。以下同じ。）上で随時掲載する本サービスに関するルール、諸規定等は本規約の一部を構成するものとします。
      </p>
      <SmallHeading>
        <Point>第3条</Point>サービスの登録
      </SmallHeading>
      <p>
        1.
        本サービスの利用を希望する者（以下「登録希望者」と言います。）は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録事項」と言います。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。
      </p>
      <p>
        2.
        当社は、当社の基準に従って、第1項に基づいて登録申請を行った登録希望者（以下「登録申請者」と言います。）の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。登録申請者のお客様としての登録は、当社が本項の通知を行ったことをもって完了したものとします。
      </p>
      <p>
        3.
        前項に定める登録の完了時に、本規約に基づくサービス利用契約がお客様と当社の間に成立し、お客様は本サービスを本規約に従い利用することができるようになります。
      </p>
      <p>
        4.
        当社は、第1項に基づき登録を申請した者が、以下の各号のいずれかの事由に該当する場合は、登録を拒否することがあります。
      </p>
      <p>
        (1)
        適用のある法令もしくは本規約に違反するおそれがあると当社が判断した場合
      </p>
      <p>
        (2)
        当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合
      </p>
      <p>(3) 過去に本サービスの利用の登録を取り消された者である場合</p>
      <p>
        (4)
        未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合
      </p>
      <p>
        (5)
        反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合
      </p>
      <p>
        (6) その他、当社が合理的な判断に基づいて、登録を適当でないと判断した場合
      </p>
      <p>
        5.
        お客様は、登録情報に変更があった場合は、遅滞なく、当社の定める方法により、当該変更事項を当社に通知し、当社から要求された資料を提出するものとします。
      </p>
      <p>
        6.
        本サービスの登録をしていただくには、お客様自身のメールアドレス及びパスワードの設定が必要となります。
      </p>
      <SmallHeading>
        <Point>第4条</Point>メールアドレス及びパスワードの管理
      </SmallHeading>
      <p>
        1.
        お客様は、自己の責任において、メールアドレス及びパスワードを管理及び保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等をしてはならないものとします。
      </p>
      <p>
        2.
        メールアドレス及びパスワードの管理不十分、使用上の過誤、第三者の使用等による損害の責任はお客様が負うものとし、当社は一切の責任を負いません。
      </p>
      <p>
        3.
        お客様は、メールアドレス及びパスワードが盗まれ、又は第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。
      </p>
      <SmallHeading>
        <Point>第5条</Point>チケットの購入・決済
      </SmallHeading>
      <p>
        1.
        本サービスを利用して購入したチケットの料金支払については、別途当社が定める方法に従うものとします。
      </p>
      <p>
        2.
        当社は、決済事業者（決済サービスを提供する事業者を意味します。以下同じ。）との間で、決済サービス契約を締結することができます。ただし、決済事業者に関する手数料は、当社にて負担することとします。
      </p>
      <p>
        3.
        本サービスにおいて、お客様の入力ミスまたは通信環境の不具合等により重複して申込みをされた場合でも、当社は一切責任を負いません。また、その代金についての払戻しはいたしません。
      </p>
      <p>
        4.
        本サービスにおいて、お客様がチケット購入申込み時に指定可能な事項は、販売画面で選択可能な範囲に限ります。
      </p>
      <p>
        5.
        本サービスはインターネットを利用したリアルタイムチケット購入システムであるため、通信回線の混雑またはコンピューターシステム上の不慮の事故等により、チケット購入の成否の確定もしくはその通知が大幅に遅れ、または不可能となる場合があります。
      </p>
      <p>
        6.
        当社は、前項に定めるチケット購入の成否について、お客様および第三者に対し一切責任を負いません。
      </p>
      <p>
        7.
        お客様は、他人のクレジットカードの利用もしくは虚偽のクレジットカード情報の入力等のクレジットカードに関する不正行為、その他当社が不適切と認める行為を行ってはならないものとします。当社は、お客様がかかる行為を行ったことにより生じた損害について、当該お客様に対して賠償を求めることができます。
      </p>
      <p>
        8.
        チケットの購入申込みの完了後、当社よりご購入確認の電子メールを送信させていただきます。チケット購入申込み時のオーダーフォームへの入力漏れ、正しくない電子メールアドレスの入力、判読不可能な文字化け現象等、お客様からのお申込み内容に何らかの不具合が生じた場合、電子メールを送信できないことがあります。電子メールの不達・誤達・遅達等について当社は一切責任を負いません。
      </p>
      <SmallHeading>
        <Point>第6条</Point>チケットのキャンセル・日時変更・払戻し
      </SmallHeading>
      <p>
        1.
        本サービスでの購入申込み完了後は、その理由の如何にかかわらず、チケットのキャンセル、日時変更及び払戻しは一切受け付けていません。
      </p>
      <p>
        2
        天候不良等により当社判断のもと個別ゲーム開催が中止となった場合は、当社は当社所定の方法によりお客様に通知するものとします。また、この場合には、お客様の希望に応じて、当社所定の方法により購入されたチケットの日時変更あるいは払戻しを受け付けます。
      </p>
      <p>
        3.
        第2項に基づきお客様が払戻しを希望した場合は、当社からの払戻し金額はチケット券面額に限り、それ以外の費用（会場までの旅費等）は適用外となります。また、払戻し方法は別途当社が指定する方法により行われます。
      </p>
      <SmallHeading>
        <Point>第7条</Point>登録取消等
      </SmallHeading>
      <p>
        1.
        当社は、お客様が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該お客様について本サービスの利用を一時的に停止もしくは利用履歴を削除し、又はお客様としての登録を取り消すことができます。
      </p>
      <p>(1) 本規約のいずれかの条項に違反した場合</p>
      <p>(2) 登録情報に虚偽の事実があることが判明した場合</p>
      <p>
        (3)
        当社、他のお客様、その他の第三者に損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合
      </p>
      <p>
        (4)
        手段の如何を問わず、本サービスの運営を妨害した場合、又は当社の信用を毀損する場合もしくはそのおそれがあると当社が判断した場合
      </p>
      <p>
        (5)
        支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合
      </p>
      <p>
        (6)
        自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき
      </p>
      <p>(7) 差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合</p>
      <p>(8) 租税公課の滞納処分を受けた場合</p>
      <p>
        (9) 死亡した場合又は後見開始、保佐開始若しくは補助開始の審判を受けた場合
      </p>
      <p>
        (10)
        お客様が一定期間にわたって本サービスの利用が見受けられない場合又は利用する見込みがないと合理的な判断基準に基づいて、当社が判断した場合
      </p>
      <p>(11) 第3条第4項各号に該当する場合</p>
      <p>
        (12) その他、当社がお客様としての登録の継続を適当でないと判断した場合
      </p>
      <p>
        2.
        前項各号のいずれかの事由に該当した場合、お客様は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
      </p>
      <p>
        3.
        当社は、１日前までに当社所定の方法でお客様に通知することにより、お客様の登録を取り消すことができます。
      </p>
      <p>
        4.登録が取り消されると、本サービスの利用履歴は消滅します。第8条に基づきお客様が誤って登録を取り消した場合であっても復元はできませんのでご注意ください。
      </p>
      <p>
        5.
        当社は、本条に基づき当社が行った行為によりお客様に生じた損害について一切の責任を負いません。
      </p>
      <p>
        6.
        本条に基づきお客様の登録が取り消された場合、お客様は、当社の指示に基づき、当社から提供を受けた本サービスに関連するソフトウェア、マニュアルその他の物につき、返還、廃棄その他の処分を行うものとします。
      </p>
      <SmallHeading>
        <Point>第8条</Point>退会
      </SmallHeading>
      <p>
        1.
        お客様は、当社所定の方法で当社に通知することにより、本サービスから退会し、自己のお客様としての登録を抹消することができます。
      </p>
      <p>
        2.
        退会にあたり、当社に対して負っている債務が有る場合は、お客様は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
      </p>
      <SmallHeading>
        <Point>第9条</Point>禁止事項
      </SmallHeading>
      <p>
        1.
        お客様は、本サービスの利用に際して、以下に記載することを行なってはなりません。
      </p>
      <p>
        (1)
        本サービスの内容のうち、チケットを購入したお客様のみが知ることができる内容をインターネットに投稿する等、広く第三者に知らしめる行為（いわゆるネタバレを行う行為。）。
      </p>
      <p>(2) 転売目的によるチケットの購入および購入したチケットの転売</p>
      <p>
        (3)
        目的の如何を問わず、本サイトにおけるチケット販売価格より高い価格で転売し、または転売を試みる行為、およびオークションもしくはインターネットチケットオークションにかけて転売し、または転売を試みる行為
      </p>
      <p>
        (4)
        本サービスをご利用される他のお客様もしくは第三者に迷惑もしくは不利益を及ぼす行為、または本サービスもしくはその他のサービスに支障を来す行為
      </p>
      <p>(5) 法令に違反する行為</p>
      <p>
        (6)
        権利者の許諾を得ることなく、いかなる方法によっても、本サービスを通じて提供される著作物等を著作権法で定める個人の私的使用の範囲を超えて使用する行為
      </p>
      <p>
        (7)
        本サービスを通じて、もしくは本サービスに関連して営利を目的とする行為またはその準備を目的とする行為
      </p>
      <p>
        (8)
        コンピューターウィルス等の有害なプログラムを、本サービスを通じて、もしくは本サービスに関連して使用し、または提供する行為
      </p>
      <p>
        (9)
        公序良俗に反する、もしくはその恐れのある行為、または公序良俗に反する情報を本サービスをご利用される他のお客様もしくは第三者に提供する行為
      </p>
      <p>(10) 政治・宗教・性風俗に関する行為</p>
      <p>
        (11)
        当社又は当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これらに限定されません。）
      </p>
      <p>(12) 異性交際を目的として本サービスを利用する行為</p>
      <p>(13) お客様に適用される規則に違反する行為</p>
      <p>(14) その他、当社が不適切と判断する行為</p>
      <p>
        2.
        当社において、第1項の禁止行為の何れかに該当する違反行為を確認した場合には、禁止行為によって購入し、または禁止行為によって処分し、もしくは処分することを試みたチケットについては無効とし、個別ゲーム参加を認めません。また、既に当該チケットによって個別ゲームに参加している場合には、退場させることがあります。これらの場合、当社は当該チケットの代金を一切返金しないものとします。
      </p>
      <p>
        3.
        当社から直接購入する以外の方法により購入したチケットに関するトラブルについては、当社は一切責任を負わないものとします。
      </p>
      <p>
        4.
        お客様は、インターネット利用の一般的なマナー、モラルおよび技術を遵守しなければなりません。
      </p>
      <SmallHeading>
        <Point>第10条</Point>著作権
      </SmallHeading>
      <p>
        1.
        お客様は、当社の許諾を得ないで、いかなる方法においても、本サービスを通じて提供される全ての情報及びファイルについて、著作権法で定めるお客様個人の私的利用の範囲外での使用をすることはできないものとします。
      </p>
      <p>
        2.
        お客様は、当社の許諾を得ないで、いかなる方法においても、第三者をして本サービスを通じて提供される全ての情報及びファイルについて、使用・公開等させることはできないものとします。
      </p>
      <p>
        3.
        本条の規定に違反して紛争が発生した場合、お客様は、自己の費用と責任において、当該紛争を解決するとともに、当社及び第三者に損害を与えないものとします。
      </p>
      <SmallHeading>
        <Point>11条</Point>サービスの中止・中断・終了
      </SmallHeading>
      <p>
        1.
        当社は、以下の事項に該当する場合、事前の通知をすることなく本サービスの運営を中止または中断することができるものとします。この場合、本サービスの運営の中止又は中断によりお客様に発生した損害については、当社は一切その責任を負わないものとします。
      </p>
      <p>(1) 本サービスの保守を定期的または緊急に行う場合</p>
      <p>
        (2)
        戦争、暴動、騒乱、労働争議、地震、噴火、洪水、津波、火災、停電その他の非常事態により、本サービスの提供が通常通りできなくなった場合
      </p>
      <p>(3) 本規約に反する事実があり、当社が必要と判断した場合</p>
      <p>
        (4) その他、当社が本サービスの運営上、一時的な中断が必要と判断した場合
      </p>
      <p>
        2.
        当社は、当社の都合により、本サービスの提供を終了することができます。この場合、当社は登録ユーザーに事前に通知するものとします。この場合、本サービスの終了によりお客様に発生した損害については、当社は一切その責任を負わないものとします。
      </p>
      <SmallHeading>
        <Point>第12条</Point>有効期間
      </SmallHeading>
      <p>
        サービス利用契約は、お客様について第3条に基づく登録が完了した日に効力を生じ、お客様の登録が取り消された日又は本サービスの提供が終了した日のいずれか早い日まで、当社とお客様との間で有効に存続するものとします。
      </p>
      <SmallHeading>
        <Point>第13条</Point>本規約等の変更
      </SmallHeading>
      <p>1. 当社は、本サービスの内容を自由に変更できるものとします。</p>
      <p>
        2.
        当社は、本規約（当社ウェブサイトに掲載する本サービスに関するルール、諸規定等を含みます。以下本項において同じ。）を変更できるものとします。当社は、本規約を変更した場合には、お客様に当該変更内容を通知するものとし、当該変更内容の通知後、お客様が本サービスを利用した場合又は当社の定める期間内に登録取消の手続をとらなかった場合には、お客様は、本規約の変更に同意したものとみなします。
      </p>
      <SmallHeading>
        <Point>第14条</Point>免責等
      </SmallHeading>
      <p>
        1.
        本サービスのご利用に際し、サービス提供がプロバイダー等第三者もしくはシステムのトラブルにより不可能となった場合には、当社は責任を負わないものとします。
      </p>
      <p>
        2.
        お客様の個別ゲーム参加中に万が一、事件・事故・盗難などが起こっても、当社は一切の責任を負わないものとします。
      </p>
      <p>
        3.
        お客様が当社から直接又は間接に、本サービス、当社ウェブサイト、本サービスの他のお客様その他の事項に関する何らかの情報を得た場合であっても、当社はお客様に対し本規約において規定されている内容を超えて如何なる保証も行うものではありません。
      </p>
      <p>
        4.
        お客様は、本サービスを利用することが、お客様に適用のある法令、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、お客様による本サービスの利用が、お客様に適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。
      </p>
      <p>
        5.
        当社は、当社による本サービスの提供の中断、停止、終了、利用不能又は変更、お客様のメッセージ又は情報の削除又は消失､お客様の登録の取消、本サービスの利用によるデータの消失又は機器の故障若しくは損傷、その他本サービスに関連してお客様が被った損害につき、賠償する責任を一切負わないものとします。
      </p>
      <p>
        6.
        当社ウェブサイトから他のウェブサイトへのリンク又は他のウェブサイトから当社ウェブサイトへのリンクが提供されている場合でも、当社は、当社ウェブサイト以外のウェブサイト及びそこから得られる情報に関して如何なる理由に基づいても一切の責任を負わないものとします。
      </p>
      <p>
        7.
        当社は、本サービスに関連してお客様が被った損害について、一切賠償の責任を負いません。消費者契約法の適用その他の理由により当社がお客様に対して損害賠償責任を負う場合においても、当社の賠償責任は、損害の事由が生じた時点から遡って過去３ヵ月の期間にお客様から現実に受領したチケットの代金の総額を上限とします。
      </p>
      <SmallHeading>
        <Point>第15条</Point>個人情報の取扱い
      </SmallHeading>
      <p>
        当社は、お客様の情報については当社のプライバシーポリシーに従って取り扱うものとし、お客様はこれに同意するものとします。
      </p>
      <SmallHeading>
        <Point>第16条</Point>連絡方法
      </SmallHeading>
      <p>
        本サービスに関する当社からお客様への連絡は、当社ウェブサイト内の適宜の場所への掲示その他、当社が適当と判断する方法により行ないます。
      </p>
      <p>
        本サービスに関するお客様から当社への連絡は、当社ウェブサイト内の適宜の場所に設置するお問い合わせフォームの送信または当社が指定する方法により行っていただきます。
      </p>
      <SmallHeading>
        <Point>第17条</Point>サービス利用契約上の地位の譲渡等
      </SmallHeading>
      <p>
        1.
        お客様は、当社の書面による事前の承諾なく、サービス利用契約上の地位又は本規約に基づく権利もしくは義務を第三者に譲渡し、又は担保に供することはできません。
      </p>
      <p>
        2.
        当社は本サービスにかかる事業を他の団体に譲渡した場合には、当該事業譲渡に伴いサービス利用契約上の地位、本規約に基づく権利及び義務並びにお客様の登録事項その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、お客様は、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
      </p>
      <SmallHeading>
        <Point>第18条</Point>分離可能性
      </SmallHeading>
      <p>
        本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
      </p>
      <SmallHeading>
        <Point>第19条</Point>存続規定
      </SmallHeading>
      <p>
        第4条第2項、第5条第3項及び第6項から第8項まで、第7条第2項、第8条第4項から第6項まで、第8条第2項、第9条、第10条、第11条第2項、第14条、第15条、並びに第17条から第20条までの規定はサービス利用契約の終了後も有効に存続するものとします。
      </p>
      <SmallHeading>
        <Point>第20条</Point>準拠法、裁判管轄
      </SmallHeading>
      <p>
        本規約は日本語を正文とし、その準拠法は日本法とします。本サービスに起因または関連してお客様と当社との間に生じた紛争については東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
      </p>
      <p>以上</p>
      <p>制定日：2018年6月6日</p>
    </Container>
  );
};

export default TermsOfService;
